import React from "react";
import { Team, UserRole } from "../types";
import "./Sidebar.css";

const packageJson = require("../../package.json");

interface SidebarProps {
  teams: Team[];
  selectedTeam: string;
  onTeamSelect: (teamId: string) => void;
  userRole: UserRole;
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  teams,
  selectedTeam,
  onTeamSelect,
  userRole,
  sidebarOpen,
  onToggleSidebar,
}) => {
  const [equipesExpanded, setEquipesExpanded] = React.useState(true);
  const [relatoriosExpanded, setRelatoriosExpanded] = React.useState(true);
  const handleNewInvoice = () => {
    window.open("/new", "_blank");
  };

  const handleReports = (reportType: string) => {
    const reportUrls: { [key: string]: string } = {
      general: "/reports/general",
      byCode: "/reports/by-code",
      byTeam: "/reports/by-team",
      byType: "/reports/by-type",
      coelba: "/reports/coelba",
      paid: "/reports/paid",
      paidSummary: "/reports/paid-summary",
      daily: "/reports/daily",
      monthly: "/reports/monthly",
      faturamentoReal: "/reports/faturamento-real",
    };

    if (reportUrls[reportType]) {
      window.open(reportUrls[reportType], "_blank");
    }
  };

  const handleAdmin = () => {
    window.open("/admin", "_blank");
  };

  return (
    <nav className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
      <div className="sidebar-header">
        <h3>Orca Engenharia</h3>
      </div>

      <div className="sidebar-content">
        <div className="sidebar-section">
          <button
            className="section-title-collapsible"
            onClick={() => setEquipesExpanded(!equipesExpanded)}
          >
            <span>Equipes</span>
            <i
              className={`fas ${equipesExpanded ? "fa-chevron-down" : "fa-chevron-right"}`}
            ></i>
          </button>
          {equipesExpanded && (
            <ul className="teams-list">
              {teams.map((team) => (
                <li
                  key={team.id}
                  className={selectedTeam === team.id ? "active" : ""}
                >
                  <button
                    onClick={() => onTeamSelect(team.id)}
                    className="team-button"
                  >
                    {team.name}
                    {team.notificationCount && team.notificationCount > 0 && (
                      <span className="notification-badge">
                        {team.notificationCount}
                      </span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="sidebar-section">
          <button
            className="section-title-collapsible"
            onClick={() => setRelatoriosExpanded(!relatoriosExpanded)}
          >
            <span>Relatórios</span>
            <i
              className={`fas ${relatoriosExpanded ? "fa-chevron-down" : "fa-chevron-right"}`}
            ></i>
          </button>
          {relatoriosExpanded && (
            <ul className="reports-list">
              <li>
                <button
                  onClick={() => handleReports("general")}
                  className="report-button"
                >
                  Geral
                </button>
              </li>
              {/*<li>
                <button
                  onClick={() => handleReports("byCode")}
                  className="report-button"
                >
                  Por Código
                </button>
              </li>*/}
              <li>
                <button
                  onClick={() => handleReports("byTeam")}
                  className="report-button"
                >
                  Por Equipe
                </button>
              </li>
              {userRole === "admin" && (
                <li>
                  <button
                    onClick={() => handleReports("byType")}
                    className="report-button"
                  >
                    Por Tipo
                  </button>
                </li>
              )}

              {/*{(userRole === 'admin' || userRole === 'func') && (
                <li>
                  <button onClick={() => handleReports('coelba')} className="report-button">
                    Coelba
                  </button>
                </li>
              )}*/}
              <li>
                <button
                  onClick={() => handleReports("paid")}
                  className="report-button"
                >
                  Pagos
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleReports("paidSummary")}
                  className="report-button"
                >
                  Pagos (Resumo)
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleReports("daily")}
                  className="report-button"
                >
                  Relatório Diário
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleReports("faturamentoReal")}
                  className="report-button"
                >
                  Faturamento Real
                </button>
              </li>
              {userRole === "admin" && (
                <li>
                  <button
                    onClick={() => handleReports("monthly")}
                    className="report-button"
                  >
                    Relatório Mensal
                  </button>
                </li>
              )}
            </ul>
          )}
        </div>

        {userRole === "admin" && (
          <div className="sidebar-section">
            <h4 className="section-title">Admin</h4>
            <ul className="admin-list">
              <li>
                <button onClick={handleAdmin} className="admin-button">
                  <i className="fas fa-users-cog"></i>
                  Gerenciar Usuários
                </button>
              </li>
            </ul>
          </div>
        )}

        <div className="sidebar-section">
          <button onClick={handleNewInvoice} className="new-invoice-button">
            <i className="fas fa-plus"></i>
            Novo Boletim
          </button>
        </div>
      </div>

      <div className="sidebar-footer">
        <div className="version-info">
          <span className="version-label">Versão</span>
          <span className="version-number">{packageJson.version}</span>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
